// extracted by mini-css-extract-plugin
module.exports = {"highScoresContainer":"HighScores_highScoresContainer__KCO61"};